export function buildURLWithQueryString(url, params) {
  const existingParams = Object.fromEntries(Array.from(new URLSearchParams(window.location.search)));
  const queryString = createQueryString({...existingParams, ...params});
  const path = window.location.href.split('?')[0];

  return `${path}${queryString ? `?${queryString}` : ''}`;
}

function createQueryString(params) {
  const searchParams = new URLSearchParams();

  function processValue(key, value) {
    if (value === null || value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach(item => {
        searchParams.append(`${key}[]`, item);
      });
    } else if (typeof value === 'object' && value !== null) {
      Object.entries(value).forEach(([nestedKey, nestedValue]) => {
        processValue(`${key}[${nestedKey}]`, nestedValue);
      });
    } else {
      searchParams.append(key, value);
    }
  }

  // Iterate through all params
  Object.entries(params).forEach(([key, value]) => {
    processValue(key, value);
  });

  return searchParams.toString();
}
